import useElementHeights from './useElementHeights';

const headerScrollPersistentIds = ['main-header'];

export const useSiteHeaderHeight = () => {
  return useElementHeights(headerScrollPersistentIds);
};
